import React, { Component } from "react";
import WasteTopBanner from "./wastetopbanner";

class FoodWasteTopBanner extends Component {
  render() {
    return (
      <div className="topBannerContainer">
        <div
          className="foodwaste firstSegment"
          aria-label="Food Waste Collection"
          src="/hero-food.jpg"
          alt="Food Waste Collection"
        >
          <WasteTopBanner />
        </div>
      </div>
    );
  }
}

export default FoodWasteTopBanner;
